function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import SideBar from '@/components/SideBar';
import { useOutlet } from 'react-router';
import DashboardNavbar from '../DashboardNavbar';
import styles from './SideBarLayout.module.scss';
import { AppShell } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import classNames from 'classnames';
import { useBreakpointValue } from '@/hooks/useBreakpointValue';
function SideBarLayout(param) {
    var children = param.children, topNavItems = param.topNavItems, bottomNavItems = param.bottomNavItems;
    var outlet = useOutlet();
    var _useDisclosure = _sliced_to_array(useDisclosure(), 2), opened = _useDisclosure[0], toggle = _useDisclosure[1].toggle;
    var collapseHeader = useBreakpointValue({
        base: false,
        md: true
    });
    if (children == null && outlet == null) {
        throw new Error('Requires children or an Outlet');
    }
    return /*#__PURE__*/ _jsxs(AppShell, {
        header: {
            height: 60,
            collapsed: collapseHeader
        },
        navbar: {
            width: 300,
            breakpoint: 'md',
            collapsed: {
                mobile: !opened
            }
        },
        children: [
            /*#__PURE__*/ _jsx(AppShell.Header, {
                className: styles.header,
                children: /*#__PURE__*/ _jsx(DashboardNavbar, {
                    topNavItems: topNavItems,
                    bottomNavItems: bottomNavItems,
                    sidebarDrawerHandlers: {
                        toggle: toggle
                    },
                    sidebarDrawerOpen: opened
                })
            }),
            /*#__PURE__*/ _jsx(AppShell.Navbar, {
                className: styles.navBar,
                children: /*#__PURE__*/ _jsx(SideBar, {
                    topNavItems: topNavItems,
                    bottomNavItems: bottomNavItems
                })
            }),
            /*#__PURE__*/ _jsx(AppShell.Main, {
                className: classNames(styles.scrollBar, styles.main),
                children: children !== null && children !== void 0 ? children : outlet
            })
        ]
    });
}
export default SideBarLayout;
